import './App.css';
import Router from './components/Router';
// import Context from './components/Context';

function App() {

  return (
    <div className="App">
        {/* <Context.Provider> */}
        <Router />
        {/* </Context.Provider> */}
    </div>
  );
}

export default App;